"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stakeToMsol = exports.getTokenBalanceForOwner = void 0;
const spl_token_0_4_x_1 = require("@solana/spl-token-0.4.x");
const marinade_ts_sdk_1 = require("@marinade.finance/marinade-ts-sdk");
async function getTokenBalanceForOwner(connection, mint, owner) {
    const ata = (0, spl_token_0_4_x_1.getAssociatedTokenAddressSync)(mint, owner, true);
    try {
        const balance = await connection.getTokenAccountBalance(ata);
        return balance.value.amount;
    }
    catch (e) {
        if (e.message.includes('could not find account')) {
            return '0';
        }
        throw e;
    }
}
exports.getTokenBalanceForOwner = getTokenBalanceForOwner;
async function stakeToMsol(provider, amount, options) {
    if (!provider.sendAndConfirm) {
        throw Error('missing: provider.sendAndConfirm');
    }
    const owner = provider.publicKey;
    if (!owner) {
        throw Error('missing: provider.publicKey');
    }
    const marinade = new marinade_ts_sdk_1.Marinade(new marinade_ts_sdk_1.MarinadeConfig({
        connection: provider.connection,
        publicKey: owner,
    }));
    const { transaction } = await marinade.deposit(amount);
    const signature = await provider.sendAndConfirm(transaction, undefined, {
        ...(options ?? {}),
        commitment: options?.commitment ?? 'finalized',
        skipPreflight: options?.skipPreflight ?? true,
        maxRetries: options?.maxRetries ?? 5,
    });
    const txs = await provider.connection.getParsedTransactions([signature]);
    return txs[0];
}
exports.stakeToMsol = stakeToMsol;
//# sourceMappingURL=program.js.map